export const ADMIN='Admin'
export const IB='Ib Linked'
export const COMMON_USER='Common User'
export const CUSTOMER_SUPPORT_USER='Customer Support User'


// WEBPACK FOOTER //
// ./src/constants/userPermissions.js